import { useEffect, useState } from 'react';
import { ComboBox, Item, Key, Text } from '@adobe/react-spectrum';
import { DataComponentProps } from './DataComponentProps';
import { useTranslation } from 'react-i18next';

// Extended interface to handle FormControl usage
export interface IUserDropDownProps extends DataComponentProps {
  userType?: string;
  status?: string;
}

// Interface for FormControl usage
interface UserDropDownFormControlProps {
  component: any;
  updateData: (key: string, value: any) => void;
  getData: (key: string, default_value: any) => any;
}

const UserDropDown: React.FC<IUserDropDownProps> = ({ 
  compKey, 
  label, 
  width, 
  isRequired, 
  onValueChange, 
  value: dvalue, 
  onBlur,
  userType,
  status 
}) => {
  const { t } = useTranslation();
  const _t = (key: string) => t(`newContextDialog.dataComponents.${key}`, { ns: 'finder' });
  const message = _t('is_required').split('[content]').join(label);
  const [errorMessage, setErrorMessage] = useState(isRequired ? message : '');
  const [value, setValue] = useState<Key | null>('');
  const [input, setInput] = useState('');

  useEffect(() => {
    setValue(dvalue as Key);
    if(dvalue === '-1'){
      setErrorMessage(message);
    }
  }, [dvalue]);
  
  const onSelectionChange = (value: Key | null) => {
    if(onValueChange)
        onValueChange(value ? value.toString() : '', input);
    setValue(value);
    if(isRequired && !value) 
      setErrorMessage(message);
    else 
      setErrorMessage('');  
  };

  const onInputChange = (value: string) => {
    setInput(value);
    if(isRequired && !value) 
      setErrorMessage(message);
    else 
      setErrorMessage('');
  }

  // Mock data for now - this will be replaced with actual API integration
  const mockUsers = [
    { id: '1', name: 'John Doe', email: 'john@example.com' },
    { id: '2', name: 'Jane Smith', email: 'jane@example.com' },
    { id: '3', name: 'Bob Johnson', email: 'bob@example.com' },
  ];

  return (
    <Text>User selector coming soon</Text>
    // <ComboBox 
    //   key={compKey} 
    //   label={label} 
    //   width={width} 
    //   isRequired={isRequired} 
    //   selectedKey={value}
    //   onSelectionChange={onSelectionChange} 
    //   onInputChange={onInputChange}
    //   validationState={errorMessage ? 'invalid' : undefined}
    //   errorMessage={errorMessage}
    //   onBlur={onBlur}
    //   >
    //   {mockUsers.map((user) => (
    //     <Item key={user.id}>
    //       {user.name} ({user.email})
    //     </Item>
    //   ))}
    // </ComboBox>
  );
};

// Wrapper component for FormControl usage
export const UserDropDownFormControl: React.FC<UserDropDownFormControlProps> = ({ 
  component, 
  updateData, 
  getData 
}) => {
  const handleValueChange = (value: any) => {
    updateData(component.FORMITEM, value);
  }

  return (
    <UserDropDown
      compKey={component.FORMITEM}
      label={component.PROPERTIES.name || component.PROPERTIES.caption || 'User'}
      width={'100%'}
      value={getData(component.FORMITEM, '')}
      isRequired={component.PROPERTIES.required === 'true'}
      onValueChange={handleValueChange}
      userType={(component.PROPERTIES as any).userType}
      status={(component.PROPERTIES as any).status}
    />
  );
};

export default UserDropDown; 